import { api } from './client';
import { Room } from './reservations';

export const roomsApi = {
  getAllRooms: async () => {
    const response = await api.get('/rooms');
    return response.data.data as Room[];
  },

  getAllRoomsForManagement: async () => {
    const response = await api.get('/rooms/management/all');
    return response.data.data as Room[];
  },

  getRoomById: async (id: string) => {
    const response = await api.get(`/rooms/${id}`);
    return response.data.data as Room;
  },

  getAvailableRooms: async (date: string) => {
    const response = await api.get(`/rooms/available/${date}`);
    return response.data.data as Room[];
  },

  getRoomPassword: async (id: string) => {
    const response = await api.get(`/rooms/${id}/password`);
    return response.data.data.password as string;
  },

  updateRoomPassword: async (id: string, password: string) => {
    const response = await api.put(`/rooms/${id}/password`, { password });
    return response.data;
  },

  createRoom: async (data: {
    building: string;
    roomNumber: string;
    roomType: string;
    maxOccupancy?: number;
    standardOccupancy?: number;
    status?: string;
    features?: string;
    password?: string;
  }) => {
    const response = await api.post('/rooms', data);
    return response.data.data as Room;
  },

  updateRoom: async (
    id: string,
    data: {
      building?: string;
      roomNumber?: string;
      roomType?: string;
      maxOccupancy?: number;
      standardOccupancy?: number;
      status?: string;
      features?: string;
      password?: string;
    }
  ) => {
    const response = await api.put(`/rooms/${id}`, data);
    return response.data.data as Room;
  },

  deleteRoom: async (id: string) => {
    const response = await api.delete(`/rooms/${id}`);
    return response.data;
  },
};

